import 'antd/dist/antd.css';
import ReactDOM from 'react-dom/client';

import { SingleInstanceGuard } from '@/utils/check-single-instance.ts';

import App from './containers/App.tsx';
import './styles/tailwind.css';

new SingleInstanceGuard({
  restrictedPaths: ['/arc'], // Only restrict single instance under / path
  onSecondInstance: () => {
    alert('Cannot open multiple instances of the application.');
    window.location.replace('about:blank');
  },
});
const rootElement = document.getElementById('root')!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);

  root.render(<App />);
}
